import { render, staticRenderFns } from "./Completion.vue?vue&type=template&id=6447c0ac&scoped=true"
import script from "./Completion.vue?vue&type=script&lang=js"
export * from "./Completion.vue?vue&type=script&lang=js"
import style0 from "./Completion.vue?vue&type=style&index=0&id=6447c0ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6447c0ac",
  null
  
)

export default component.exports